module.exports = __webpack_public_path__ + "static/media/sell_help_15.012e8da9.png";